<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="id" v-if="formType === 1">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.') }}<template slot="title">{{ $t('举报.') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.id" :placeholder="$t('通用.输入.请输入') + $t('举报.')" />
      </a-form-model-item>
      <a-form-model-item prop="shopId">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.店铺id') }}<template slot="title">{{ $t('举报.店铺id') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.shopId" :placeholder="$t('通用.输入.请输入') + $t('举报.店铺id')" />
      </a-form-model-item>
      <a-form-model-item prop="type">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.举报类型 1：商品 2：视频  3：店铺  4：直播间 5：评论')
            }}<template slot="title">{{ $t('举报.举报类型 1：商品 2：视频  3：店铺  4：直播间 5：评论') }}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="reportContentId">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.被举报内容id') }}<template slot="title">{{ $t('举报.被举报内容id') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reportContentId" :placeholder="$t('通用.输入.请输入') + $t('举报.被举报内容id')" />
      </a-form-model-item>
      <a-form-model-item prop="reportCause">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.举报类型') }}<template slot="title">{{ $t('举报.举报类型') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.reportCause"
          :maxLength="20"
          :placeholder="$t('通用.输入.请输入') + $t('举报.举报类型')"
        />
      </a-form-model-item>
      <a-form-model-item prop="reportUser">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.举报人id') }}<template slot="title">{{ $t('举报.举报人id') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reportUser" :placeholder="$t('通用.输入.请输入') + $t('举报.举报人id')" />
      </a-form-model-item>
      <a-form-model-item prop="reportImgs">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.举报图证明(最多6张)') }}<template slot="title">{{ $t('举报.举报图证明(最多6张)') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reportImgs" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="reportContent">
        <span slot="label">
          <a-tooltip>
            {{ $t('举报.举报内容') }}<template slot="title">{{ $t('举报.举报内容') }}</template>
          </a-tooltip>
        </span>
        <editor v-model="form.reportContent" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReport, addReport, updateReport } from '@/api/report/report'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    Editor,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        shopId: null,

        type: null,

        reportContentId: null,

        reportCause: null,

        reportUser: null,

        reportImgs: null,

        reportContent: null,

        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {},
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        shopId: null,
        type: null,
        reportContentId: null,
        reportCause: null,
        reportUser: null,
        reportImgs: null,
        reportContent: null,
        createTime: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReport({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateReport(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addReport(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
